import script from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__